export default __webpack_public_path__ + "static/media/clock.ecd39fb4.svg";